export function TestPantaris() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ padding: '1rem', backgroundColor: '#005691', color: 'white' }}>
        <h2 style={{ margin: 0 }}>Test: Pantaris Documentation (Cookie-based Auth)</h2>
        <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem' }}>
          URL: https://documentation.pantaris.io/applications/test-doc-app/9c54f6be-c6c8-11f0-a346-ebb91898a6d2/main/service-overview
        </p>
      </div>
      <iframe
        src="https://documentation.pantaris.io/applications/test-doc-app/9c54f6be-c6c8-11f0-a346-ebb91898a6d2/main/service-overview"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        allow="storage-access"
        title="Pantaris Documentation Test"
        style={{ 
          flex: 1, 
          border: 'none', 
          width: '100%',
          height: '100%'
        }}
      />
    </div>
  );
}
